import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d5fdbe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "mod_c mod_c_editor" }
const _hoisted_3 = {
  key: 0,
  class: "mod_c_title"
}

import { useRoute } from 'vue-router';
import Crumb from '@/components/Crumb.vue';
import router from '@/router';
import { RollbackOutlined } from '@ant-design/icons-vue';

const __default__ = { name: '' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();

const Cancel = () => {
  router.push('/media/videos');
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Crumb),
    _createElementVNode("div", {
      class: _normalizeClass(["mod_wrap mediaLibrary", { mediaEditor: _unref(route).name === 'VideoEditor' }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(route).name !== 'VideoEditor')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(route).meta?.title) + " ", 1),
              (_unref(route).name == 'VideoClip' || _unref(route).name == 'VideoMerge')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    onClick: Cancel
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(RollbackOutlined))
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode("视频库 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["select_none", { mod_c_tbody: _unref(route).name !== 'VideoEditor' }])
        }, [
          _createVNode(_component_router_view)
        ], 2)
      ])
    ], 2)
  ]))
}
}

})